import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const testimonials = [
  {
    name: 'Miss. Priya Sharma',
    position: 'Frequent Rider',
    content:
      '“ Prince Cabs has always been my go-to for daily office commutes. Punctual, clean cars and respectful drivers make all the difference. ”',
  },
  {
    name: 'Mr. Ravi Verma',
    position: 'Business Traveller',
    content:
      '“ I travel often for meetings, and Prince Cabs never lets me down. Timely service and professional drivers make it reliable every time. ”',
  },
  {
    name: 'Miss. Sneha Joshi',
    position: 'Traveller',
    content:
      '“ As a student, safety and affordability are key for me. Prince Cabs checks both boxes perfectly. ”',
  },
];

const sliderSettings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 700,
  autoplay: true,
  autoplaySpeed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const TestimonialSection = () => {
  return (
    <div
      className="testimonial-section"
      style={{
        backgroundImage: 'url(/images/img23.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <div className="testimonial-inner">
              <Slider {...sliderSettings}>
                {testimonials.map((testimonial, index) => (
                  <div className="testimonial-item text-center" key={index}>
                    {/* Star rating - 5 stars */}
                    <div className="testimonial-stars" style={{ fontSize: '24px', color: '#FFD700', marginBottom: '15px' }}>
                      ★★★★★
                    </div>
                    <div className="testimonial-content">
                      <p>{testimonial.content}</p>
                      <cite>
                        {testimonial.name}
                        <span className="company"> — {testimonial.position}</span>
                      </cite>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection;
